export default "__VITE_ASSET__CJrvj3Kn__"